import {GET_USER} from '../actions';

export default (state = {}, action) =>{
  switch(action.type){
      case GET_USER:
          return action.payload;

      default:
          return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/reducer_user.js